const dbKeys = ["report", "table", "detail", "hint", "sample_id", "status"];

const objHasDBFields = row =>
  Object.keys(row).some(key => dbKeys.includes(key));

export const getDatabaseErrors = file =>
  [...file.warnings, ...file.errors].filter(row => objHasDBFields(row));

export const getRegularErrors = file =>
  [...file.warnings, ...file.errors].filter(row => !objHasDBFields(row));

// const displayErrorTypes = ["error", "warn"];
export const plural = (count, str) =>
  `${count} ${str}${count !== 1 ? "s" : ""}`;

/**
 * Returns a new array with duplicate values removed
 * @param {Array} arr
 * @returns {Array}
 */
export const deDupArray = arr => [...new Set(arr)];

export const getJoiErrors = file => file.joiErrors;

const warnColor = "rgb(255, 171, 0)";
export const errorDivStyle = {
  borderRadius: "8px",
  width: "80%",
  marginLeft: "70px",
  marginTop: "7px",
  padding: "20px",
  backgroundColor: "white",
  border: `2px solid`
};
export const colors = {
  error: "rgb(182, 12, 15)",
  warning: warnColor,
  warn: warnColor,
  ok: "#5cb85c"
};
